const blog = () => {
    
}

module.exports = blog;